import { createSlice } from "@reduxjs/toolkit";

const initialSubscription = {
  planId: "",
  duration: "",
  startDate: "",
  endDate: "",
  term: "",
  renewsOn: "",
  subscriptionCost: "",
  discount: "",
  amountPayable: "",
  paymentMethod: "",
  status: "",
  option: "",
};

const initialState = {
  plans: [],
  isUniqueEmailError: false,
  isUniqueUserNameError: false,
  isUniqueCompanyNameError: false,
  isMaintenanceScreen: false,
  newSubscriptionLocal: initialSubscription,
  // feedback
  publicFeedbackQuestions: [],
  isUpdatePublicFeedbackQuestionResponse: false,
};

export const publicSlice = createSlice({
  name: "public",
  initialState,

  reducers: {
    setNewSubscriptionLocal: (state, action) => {
      state.newSubscriptionLocal = {
        ...state.newSubscriptionLocal,
        ...action.payload,
      };
    },
    resetSubscriptionLocal: (state) => {
      state.newSubscriptionLocal = initialSubscription;
    },

    getCheckUniqueEmailAction: (state, { payload }) => {},
    setCheckUniqueEmailAction: (state, { payload }) => {
      state.isUniqueEmailError = payload;
    },

    getCheckUniqueUserNameAction: (state, { payload }) => {},
    setCheckUniqueUserNameAction: (state, { payload }) => {
      state.isUniqueUserNameError = payload;
    },

    getCheckUniqueCompanyNameAction: (state, { payload }) => {},
    setCheckUniqueCompanyNameAction: (state, { payload }) => {
      state.isUniqueCompanyNameError = payload;
    },

    getAllPlanList: (state) => {},
    setAllPlanList: (state, { payload }) => {
      state.plans = payload;
    },

    getMaintenanceScreenAction: (state) => {},
    setMaintenanceScreenAction: (state, { payload }) => {
      state.isMaintenanceScreen = payload;
    },

    getPublicFeedbackQuestionAction: (state,{payload}) => {},
    setPublicFeedbackQuestionAction: (state, { payload }) => {
      console.log("payload", payload);
      // const { pagination = { currentPage: 1 }, list = [] } = payload;
      state.publicFeedbackQuestions = payload;
    },

    updatePublicFeedbackQuestionAction: (state, { payload }) => {},
    setUpdatePublicFeedbackQuestionAction: (state, { payload }) => {
      state.isUpdatePublicFeedbackQuestionResponse = payload;
    },
  },
});

const {
  setNewSubscriptionLocal,
  resetSubscriptionLocal,
  getCheckUniqueEmailAction,
  setCheckUniqueEmailAction,
  getCheckUniqueUserNameAction,
  setCheckUniqueUserNameAction,
  getAllPlanList,
  setAllPlanList,
  getMaintenanceScreenAction,
  setMaintenanceScreenAction,
  getCheckUniqueCompanyNameAction,
  setCheckUniqueCompanyNameAction,
  getPublicFeedbackQuestionAction,
  setPublicFeedbackQuestionAction,
  updatePublicFeedbackQuestionAction,
  setUpdatePublicFeedbackQuestionAction,
} = publicSlice.actions;
export {
  setNewSubscriptionLocal,
  resetSubscriptionLocal,
  getCheckUniqueEmailAction,
  setCheckUniqueEmailAction,
  getCheckUniqueUserNameAction,
  setCheckUniqueUserNameAction,
  getAllPlanList,
  setAllPlanList,
  getMaintenanceScreenAction,
  setMaintenanceScreenAction,
  getCheckUniqueCompanyNameAction,
  setCheckUniqueCompanyNameAction,
  getPublicFeedbackQuestionAction,
  setPublicFeedbackQuestionAction,
  updatePublicFeedbackQuestionAction,
  setUpdatePublicFeedbackQuestionAction,
};
export default publicSlice.reducer;
